import React from "react";

import { Outlet } from "react-router";
import Box from "@mui/material/Box";
import { useLoaderData } from "react-router-dom";

import Typography from "@mui/material/Typography";

import { getEndCustomerPrintedByID, getFiles } from "API/swesum";

export async function loader({ params }) {
  const endcustomerPrinted = await getEndCustomerPrintedByID(params.printedID);
  const files = await getFiles();

  return { endcustomerPrinted, files };
}

export function EndCustomerPrintedPage() {
  const { files, invoices, endcustomerPrinted } = useLoaderData();

  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {"Fakturautskrift - "}
          {endcustomerPrinted.Id}
        </Typography>
        <Outlet context={[files]} />
      </Box>
    </Box>
  );
}
